'use strict';
import { openNewMailWithContact } from 'App/helpers/mailHelpers';

angular.module('upDirectives').directive('mailTo', [
	'$parse',
	'$upModal',
	'$stateParams',
	'AppService',
	function ($parse, $upModal, $stateParams, AppService) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var opts = $parse(attrs.mailTo)(scope);
				// eslint-disable-next-line promise/catch-or-return
				AppService.loadedPromise.then(function () {
					const mailActivated = AppService.getMetadata()?.map.mailActivated;
					// Only use the drawer if mail is activated, otherwise let the native mailto work
					if (Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.EMAIL) && mailActivated) {
						opts.customerId = $stateParams.customerId;
						element.on('click', function (e) {
							e.preventDefault();
							const email = e.currentTarget.href.replace('mailto:', '');
							if (email) {
								openNewMailWithContact(opts.contact);
							}
						});
					} else {
						element.attr('target', '_top');
					}
				});
			}
		};
	}
]);
